<h1 mat-dialog-title [attr.translate]="'no'">{{ translateMessage | translate}}</h1>
<h3 mat-dialog-title *ngIf="translateMessageDescription " [attr.translate]="'no'">{{ translateMessageDescription | translate}}</h3>
<div mat-dialog-actions [attr.translate]="'no'">
  <button mat-raised-button [mat-dialog-close]="true" class="c-white next-btn color-btn" style="font-style: rgb(255, 255, 255);">{{'yes' | translate}}</button>
  <button mat-raised-button (click)="closeDialog()"  class="back-btn">{{'no' | translate}}</button>
</div>
